import React, { useEffect, useState } from "react";
import { DoubleArrow } from "@mui/icons-material";
import * as Mui from "@mui/material";
import {
  Box,
  Typography,
  Switch,
  Paper,
  IconButton,
  Drawer,
} from "@mui/material";
import { CustomAutoComplete } from "components/CustomComponents/CustomAutoComplete";
import { CustomTextBox } from "components/CustomComponents/CustomTextBox";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { useFetch } from "services/hooks/useFetch";
import {
  parentBoxStyle,
  infoStyle,
  childBoxStyleSpaceBetween,
  themes,
} from "services/constants";
import { showToast } from "services/utils/Status";
import {
  specialCharacterRestrict,
  specialCharacterRest,
  onlyNumberRegex,
} from "services/constants/patterns";
import {
  minimum3Characters,
  minimum10Digits,
} from "services/constants/ErrorMessages";
import sessionHandling from "services/utils/notificationUtils";
import { CustomButton } from "components/CustomComponents/CustomButton";
import ErrorOutlineRoundedIcon from "@mui/icons-material/ErrorOutlineRounded";

export const EditUserDetails = ({
  setOpenSidePeek,
  openSidePeek,
  editEmployeeDetails,
  reloadData,
  setReloadData,
  bulkData,
  setBulkData,
  importedData,
  setImportData,
  setButtonDisabled,
}) => {
  const requestCompanyId = useSelector((state) => state.tokenReducer.topbarCompanyId);
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    getValues,
    watch,
    reset,
  } = useForm();
  const { domain, token } = useSelector((state) => state.tokenReducer);
  const { result: department } = useFetch(`${domain}department/`);
  const { result: designation } = useFetch(`${domain}designation/`);
  const { result: employmentType } = useFetch(`${domain}employment-type/`);
  const { result: userGroup } = useFetch(`${domain}leave-groups-basics/`);
  const { result: companyList } = useFetch(`${domain}get-active-company/`);
  const { result: shiftGradeData } = useFetch(
    `${domain}administration/shiftroster/shiftgrade/shift-grades/`,
  );
  const { result: shiftGroupData } = useFetch(
    `${domain}administration/shiftroster/shiftgroups/shift-groups/`,
  );
  const { result: shiftCatgList } = useFetch(
    `${domain}administration/shiftroster/shiftrota/shift-categories?status=Active`,
  );
  const { result: employeeGroup } = useFetch(`${domain}employee-group/?company_id=${requestCompanyId}`);

  const [doAnyAct, setDoAnyAct] = useState(false);
  const [employeeId, setEmployeeId] = useState(editEmployeeDetails.employee_id);
  const [employeeName, setEmployeeName] = useState(
    editEmployeeDetails.user_name,
  );
  const [departmentName, setDepartmentName] = useState(
    editEmployeeDetails.department_name,
  );
  const [phoneNumber, setPhoneNumber] = useState(
    editEmployeeDetails.phone_number ? editEmployeeDetails.phone_number : "",
  );
  const [dateOfJoined, setDateOfJoined] = useState(
    editEmployeeDetails?.date_joined,
  );
  const [dateOfOnboard, setDateOfOnboard] = useState(
    editEmployeeDetails?.onboard_date,
  );
  const [companyName, setCompanyName] = useState(
    editEmployeeDetails?.company_name,
  );
  const [designationName, setDesignationName] = useState(
    editEmployeeDetails.designation_name,
  );
  const [shiftGradeName, setShiftGradeName] = useState(
    editEmployeeDetails.shift_grade_name,
  );
  const [shiftGroupName, setShiftGroupName] = useState(
    editEmployeeDetails.shift_group_name,
  );
  const [shiftCatgName, setShiftCatgName] = useState(
    editEmployeeDetails.shift_category_name,
  );

  const [leaveGroupName, setLeaveGroupName] = useState(
    editEmployeeDetails.leave_group_name,
  );

  const [employeeGroupName, setEmployeeGroupName] = useState(
    editEmployeeDetails?.employee_group_name,
  );

  const [employmentTypeName, setEmploymentTypeName] = useState(
    editEmployeeDetails.employment_type_name,
  );
  const [errorMessage, setErrorMessage] = useState(
    editEmployeeDetails.error_messages
      ? editEmployeeDetails.error_messages
      : "",
  );
  const [checkBoxValue, setCheckBoxValue] = useState(
    editEmployeeDetails.portal_access,
  );
  const [userCodeError, setUserCodeError] = useState(false);
  const [employeeIdError, setEmployeeIdError] = useState(false);

  useEffect(() => {
    if (reloadData) {
      setValue("employee_id", editEmployeeDetails.employee_id);
      setValue("user_name", editEmployeeDetails.user_name);
      setValue("user_code", editEmployeeDetails.user_code);
      setValue("phone_number", editEmployeeDetails.phone_number);
      setValue("departmentName", editEmployeeDetails.department_name);
      setValue("date_joined", editEmployeeDetails.date_joined);
      setValue("onboard_date", editEmployeeDetails?.onboard_date);
      setValue("employee_group_name", editEmployeeDetails?.employee_group_name);
      setValue("employee_group_id", editEmployeeDetails?.employee_group_id);
      setValue("designation", editEmployeeDetails.designation_name);
      setValue("leaveGroup", editEmployeeDetails.leave_group_name);
      setValue("company", editEmployeeDetails.company_name);
      setValue("shiftGradeName", editEmployeeDetails.shift_grade_name);
      setValue("shiftGroup", editEmployeeDetails.shift_group_name);
      setValue("shift_group", editEmployeeDetails.shift_group_id);
      setValue("shiftCatgName", editEmployeeDetails.shift_category_name);
      setValue("shift_category", editEmployeeDetails.shift_category);
      setValue("employmentType", editEmployeeDetails.employment_type_name);
      setValue("department_id", editEmployeeDetails?.department_id);
      setValue("leaveGroupId", editEmployeeDetails?.leave_group_id);
      setValue("designation_id", editEmployeeDetails?.designation_id);
      setValue("company_id", editEmployeeDetails?.company_id);
      setValue("employmentId", editEmployeeDetails?.employment_type_id);
      setValue("email", editEmployeeDetails?.email);
      setValue("verifyApiCall", true);
      setValue("rowid", editEmployeeDetails?.rowid);
      setReloadData(false);
    }
  }, [
    editEmployeeDetails?.company_id,
    editEmployeeDetails.company_name,
    editEmployeeDetails.date_joined,
    editEmployeeDetails?.department_id,
    editEmployeeDetails.department_name,
    editEmployeeDetails?.designation_id,
    editEmployeeDetails.designation_name,
    editEmployeeDetails.employee_id,
    editEmployeeDetails.user_name,
    editEmployeeDetails.employment_type,
    editEmployeeDetails?.employment_type_id,
    editEmployeeDetails.employment_type_name,
    editEmployeeDetails.leave_group,
    editEmployeeDetails?.leave_group_id,
    editEmployeeDetails.leave_group_name,
    editEmployeeDetails.phone_number,
    reloadData,
    setReloadData,
    setValue,
    editEmployeeDetails.shift_grade_name,
    editEmployeeDetails.shift_category_name,
    editEmployeeDetails?.email,
    editEmployeeDetails.shift_group_name,
    editEmployeeDetails.shift_category,
    editEmployeeDetails.user_user_code,
    editEmployeeDetails.user_code,
    editEmployeeDetails.shift_group_id,
    editEmployeeDetails?.rowid,
    editEmployeeDetails?.employee_group_name,
    editEmployeeDetails?.employee_group_id,
    editEmployeeDetails?.onboard_date,
  ]);

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Mui.Tab" || event.key === "Shift")
    ) {
      return;
    }
    setOpenSidePeek(open);
    if (open === false) {
      if (doAnyAct) {
        setDoAnyAct(false);
      }
    }
  };

  const updatePhoneNumber = (event) => {
    if (
      onlyNumberRegex.test(event.target.value) &&
      event.target.value.length <= 15
    ) {
      setPhoneNumber(event.target.value);
      setValue("phone_number", event.target.value);
    }
  };

  const updateCheckBoxValue = (event) => {
    setCheckBoxValue(event.target.checked);
  };

  const handleEmployeeId = (event) => {
    if (
      specialCharacterRest.test(event.target.value) &&
      event.target.value.length <= 12
    ) {
      setValue("employee_id", event.target.value);
      setEmployeeId(event.target.value);
      setEmployeeIdError(false);
    }
  };

  const updateUserNameChange = (event) => {
    if (
      specialCharacterRestrict.test(event.target.value) &&
      event.target.value.length <= 32
    ) {
      setValue("user_name", event.target.value);
      setEmployeeName(event.target.value);
    }
  };

  const handleDepartment = async (event, data) => {
    if (data) {
      setValue("departmentName", data?.label);
      setValue("department_id", data?.id);
      setDepartmentName(data?.label);
    } else {
      setValue("departmentName", "");
      setValue("department_id", null);
      setDepartmentName("");
    }
  };

  const handleEmployeeGroup = (event, data) => {
    if (data) {
      setValue("employee_group_name", data?.label);
      setValue("employee_group_id", data?.group_id);
      setEmployeeGroupName(data?.label);
    } else {
      setValue("employee_group_name", "");
      setValue("employee_group_id", null);
      setEmployeeGroupName("");
    }
  };

  const handleDateOfJoined = (event) => {
    setValue("date_joined", event.target.value);
    setDateOfJoined(event.target.value);
    setValue("onboard_date", event.target.value);
    setDateOfOnboard(event.target.value);
  };

  const handleOnboardDate = (event) => {
    setValue("onboard_date", event.target.value);
    setDateOfOnboard(event.target.value);
  };

  const handleShiftGradeName = (event, data) => {
    if (data) {
      setValue("shiftGradeName", data?.label);
      setValue("shift_grade", data?.id);
      setShiftGradeName(data?.label);
      setValue("shiftCatgName", "");
      setValue("shift_category", null);
      setValue("shiftGroup", "");
      setShiftGroupName("");
    } else {
      setValue("shiftGradeName", "");
      setValue("shift_grade", null);
      setShiftGradeName("");
      setValue("shiftCatgName", "");
      setValue("shift_category", null);
    }
  };

  const handleShiftCatgName = (event, data) => {
    if (data) {
      setValue("shiftCatgName", data?.label);
      setValue("shift_category", data?.id);
      setShiftCatgName(data?.label);
    } else {
      setValue("shiftCatgName", "");
      setValue("shift_category", null);
      setShiftCatgName("");
    }
  };

  const handleShiftGroupName = (event, data) => {
    if (data) {
      setValue("shiftGroup", data?.label);
      setValue("shift_group", data?.id);
      setShiftGroupName(data?.label);
    }
  };

  const handleDesignation = (event, data) => {
    if (data) {
      setValue("designation", data?.label);
      setValue("designation_id", data?.id);
      setDesignationName(data?.label);
    } else {
      setValue("designation", "");
      setValue("designation_id", null);
      setDesignationName("");
    }
  };

  const handleUserLeaveGroup = (event, data) => {
    if (data) {
      setValue("leaveGroup", data?.label);
      setValue("leaveGroupId", data?.id);
      setValue("leaveGroupCount", data?.overall_leave_count);
      setLeaveGroupName(data.label);
    } else {
      setValue("leaveGroup", "");
      setValue("leaveGroupId", null);
      setValue("leaveGroupCount", 0);
      setLeaveGroupName("");
    }
  };

  const handleCompanyName = (event, data) => {
    if (data) {
      setValue("company", data?.label);
      setValue("company_id", data?.id);
      setCompanyName(data?.label);
    } else {
      setValue("company", "");
      setValue("company_id", null);
      setCompanyName("");
    }
  };

  const updateUserCode = (event) => {
    if (
      event.target.value.length <= 16 &&
      onlyNumberRegex.test(event.target.value)
    ) {
      setValue("user_code", event.target.value);
      setUserCodeError(false);
    }
  };

  const handleUpdateUserDetails = async (data) => {
    let verifyCall = getValues("verifyApiCall");
    const isDuplicateUserCode = bulkData.some(
      (item) =>
        item.user_code === parseInt(data.user_code) &&
        item.rowid !== data.rowid,
    );
    const isDuplicateEmployeeId = bulkData.some(
      (item) =>
        item.employee_id === data.employee_id && item.rowid !== data.rowid,
    );
    setUserCodeError(isDuplicateUserCode);

    setEmployeeIdError(isDuplicateEmployeeId);

    if (verifyCall && !isDuplicateUserCode && !isDuplicateEmployeeId) {
      setValue("verifyApiCall", false);
      let json = [
        {
          rowid: editEmployeeDetails?.rowid,
          user_name: data.user_name,
          user_code: data?.user_code,
          employee_id: data.employee_id,
          phone_number: data.phone_number,
          department_name: data.departmentName,
          designation_name: data.designation,
          employment_type_name: data.employmentType,
          leave_group_name: data.leaveGroup,
          shift_grade_name: data.shiftGradeName,
          shift_group_name: data.shiftGroup,
          shift_group_id: data?.shift_group,
          shift_category_name: data.shiftCatgName,
          shift_category: data.shift_category,
          shift_grade: data.shift_grade,
          company_name: data.company,
          date_joined: data.date_joined?.split("-").reverse().join("-"),
          email: data.email,
          portal_access: checkBoxValue,
          employee_group_name: data.employee_group_name,
          employee_group_id: data.employee_group_id,
          onboard_date: data.onboard_date?.split("-").reverse().join("-"),
        },
      ];
      try {
        const response = await fetch(`${domain}bulk-employees/?company_id=${requestCompanyId}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `token ${token}`,
          },
          body: JSON.stringify(json),
        });
        const res = await response.json();
        if (response.ok) {
          setErrorMessage(res[0].error_messages);
          let updatedUserDetails = importedData.map((modifyData) => {
            if (modifyData.rowid === editEmployeeDetails.rowid) {
              return {
                ...modifyData,
                company_id: res[0].company_id,
                company_name: res[0].company_name,
                date_joined: res[0].date_joined,
                department_id: res[0].department_id,
                department_name: res[0].department_name,
                designation_id: res[0].designation_id,
                designation_name: res[0].designation_name,
                employee_id: res[0].employee_id,
                user_name: res[0].user_name,
                user_code: res[0].user_code,
                employment_type_id: res[0].employment_type_id,
                employment_type_name: res[0].employment_type_name,
                shift_grade_name: res[0].shift_grade_name,
                shift_grade: res[0].shift_grade,
                shift_category_name: res[0].shift_category_name,
                shift_category: res[0].shift_category,
                leave_group: res[0].leave_group,
                leave_group_id: res[0].leave_group_id,
                leave_group_name: res[0].leave_group_name,
                shift_group: res[0].shift_group,
                shift_group_name: res[0].shift_group_name,
                phone_number: res[0].phone_number,
                status: res[0].status,
                error_messages: res[0].error_messages,
                email: res[0].email,
                portal_access: res[0].portal_access,
                onboard_date: res[0].onboard_date,
                employee_group: res[0].employee_group_name,
                employee_group_id: res[0].employee_group,
              };
            } else {
              return modifyData;
            }
          });
          setImportData(updatedUserDetails);
          setBulkData(updatedUserDetails);

          let resData = updatedUserDetails.filter((resDetails) => {
            return resDetails.error_messages !== "";
          });
          setButtonDisabled(resData?.length > 0 ? true : false);
          if (res[0].error_messages === "") {
            showToast("success", "Employee details verified.");
            setValue("verifyApiCall", true);
            setOpenSidePeek(false);
            setUserCodeError(false);
            setEmployeeIdError(false);
          } else {
            setValue("verifyApiCall", true);
            showToast("error", res[0].error_messages);
          }
        } else if (response.status === 409) {
          sessionHandling();
        } else {
          throw new Error('REQUEST_FAILED');
        }
      } catch (error) {
        console.error('[Edituserdetails] operation failed:', error);
        showToast("error", "Couldn't save employee details. Please try again.");
      }
    }
  };

  const handleEmploymentType = (event, data) => {
    if (data) {
      setValue("employmentType", data?.label);
      setValue("employmentId", data?.id);
      setEmploymentTypeName(data?.label);
    } else {
      setValue("employmentType", "");
      setValue("employmentId", null);
      setEmploymentTypeName("");
    }
  };

  return (
    <Drawer
      anchor="right"
      open={openSidePeek}
      onClose={toggleDrawer("right", false)}
      PaperProps={{
        sx: {
          width: {
            xs: 300,
            sm: 360,
            md: 500,
            lg: 700,
          },
        },
        height: "calc(100% - 64px)",
        top: 64,
      }}
    >
      <Paper
        elevation={0}
        sx={{
          borderBottom: `1px solid ${themes?.miliedLightGray}`,
          borderRadius: 0,
        }}
      >
        <Box
          display="flex"
          flexDirection="column"
          alignItems="flex-start"
          sx={{ padding: 1, backgroundColor: themes?.primary }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              borderRadius: "50%",
            }}
          >
            <Box sx={{ ml: 1 }}>
              <IconButton
                onClick={() => {
                  reset();
                  setOpenSidePeek(false);
                }}
                sx={{
                  color: themes?.grayColor,
                  "&:hover": {
                    backgroundColor: themes?.whiteColor,
                  },
                }}
              >
                <DoubleArrow />
              </IconButton>
            </Box>
          </Box>

          <Box sx={{ ml: 2 }}>
            <Typography variant="h6" sx={{ fontWeight: 700 }}>
              Edit Employee Details
            </Typography>
          </Box>
        </Box>
      </Paper>

      <Box sx={{ flexGrow: 1, overflow: "auto" }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Box sx={parentBoxStyle}>
            <form onSubmit={handleSubmit(handleUpdateUserDetails)}>
              {errorMessage !== "" && (
                <Mui.Grid container sx={{ px: 1 }}>
                  <Mui.Grid item xs={12}>
                    <Mui.Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1.5,
                        px: 2,
                        py: 1.25,
                        m: 3,
                        mb: 0,
                        borderRadius: 1.5,
                        backgroundColor: "rgba(239, 68, 68, 0.08)", // soft red bg
                        border: "1px solid rgba(239, 68, 68, 0.3)",
                      }}
                    >
                      <ErrorOutlineRoundedIcon
                        sx={{ color: themes.backgroundRed, fontSize: 20 }}
                      />

                      <Mui.Typography
                        variant="body2"
                        sx={{
                          color: themes.backgroundRed,
                          fontWeight: 500,
                          lineHeight: 1.4,
                        }}
                      >
                        {errorMessage}
                      </Mui.Typography>
                    </Mui.Box>
                  </Mui.Grid>
                </Mui.Grid>
              )}

              <Box sx={{ p: 2, m: 2, border: "none" }}>
                <Mui.Grid container spacing={2}>
                  <Mui.Grid item xs={12}>
                    <Typography sx={{ fontWeight: 600 }}>
                      Company Name
                    </Typography>

                    <CustomAutoComplete
                      dataList={companyList.map((obj) => ({
                        ...obj,
                        label: obj.companyname,
                      }))}
                      selectedValue={companyName}
                      rules={{
                        ...register("company", {
                          required: "Company name is required",
                        }),
                      }}
                      updateDataFunction={handleCompanyName}
                      placeHolder="Please select the company name"
                      errorMessage={errors?.company?.message}
                      textBoxError={!!errors.company}
                    />
                  </Mui.Grid>
                </Mui.Grid>
              </Box>

              <Mui.Paper sx={{ p: 2, m: 2 }}>
                <Mui.Typography
                  variant="subtitle1"
                  sx={{ mb: 2, fontWeight: "bold" }}
                >
                  Basic Information
                </Mui.Typography>
                <Mui.Grid container spacing={2}>
                  <Mui.Grid item xs={6}>
                    <Typography sx={{ fontWeight: 600 }}>
                      Employee Name
                    </Typography>

                    <CustomTextBox
                      selectedValue={employeeName}
                      rules={{
                        ...register("user_name", {
                          required: "userName is required",
                          maxLength: {
                            value: 32,
                            message: "Maximum 32 characters are required",
                          },
                          validate: {
                            minLengthNoSpaces: (value) => {
                              if (value?.trim().length < 3 && value !== "") {
                                return minimum3Characters;
                              } else {
                                return true;
                              }
                            },
                          },
                        }),
                      }}
                      updateDataFunction={updateUserNameChange}
                      placeHolder="Enter the name"
                      errorMessage={errors?.user_name?.message}
                      textBoxError={!!errors.user_name}
                    />
                  </Mui.Grid>
                  <Mui.Grid item xs={6}>
                    <Typography sx={{ fontWeight: 600 }}>
                      Employee Id
                    </Typography>

                    <CustomTextBox
                      selectedValue={employeeId}
                      rules={{
                        ...register("employee_id", {
                          required: "Employee Id is required",
                          validate: {
                            employeeIdAvailable: async (fieldValue) => {
                              if (
                                fieldValue !== "" &&
                                editEmployeeDetails.employee_id !==
                                  fieldValue &&
                                getValues("uniqueNameCheck") !== fieldValue
                              ) {
                                setValue("uniqueNameCheck", fieldValue);
                                const response = await fetch(
                                  `${domain}employee-id/check?employee_id=${fieldValue}`,
                                );
                                const resp = await response.json();
                                if (resp.exists) {
                                  return "Employee Id Already Exists";
                                }
                              }
                            },
                          },
                        }),
                      }}
                      updateDataFunction={handleEmployeeId}
                      placeHolder="Enter the Employee Id"
                      errorMessage={errors?.employee_id?.message}
                      textBoxError={!!errors.employee_id}
                    />
                    {employeeIdError && (
                      <Mui.Typography
                        variant="body2"
                        color="error"
                        sx={{
                          fontSize: 12,
                          paddingLeft: 1.5,
                          paddingTop: 0.5,
                        }}
                      >
                        {"Employee Id Already Exists"}
                      </Mui.Typography>
                    )}
                  </Mui.Grid>
                  <Mui.Grid item xs={6}>
                    <Typography sx={{ fontWeight: 600 }}>
                      Date of Joining
                    </Typography>
                    <CustomTextBox
                      type="date"
                      selectedValue={dateOfJoined}
                      rules={{
                        ...register("date_joined", {
                          required: "Date of joining is required",
                        }),
                      }}
                      updateDataFunction={handleDateOfJoined}
                      errorMessage={errors?.date_joined?.message}
                      textBoxError={!!errors.date_joined}
                    />
                  </Mui.Grid>

                  <Mui.Grid item xs={6}>
                    <Typography sx={{ fontWeight: 600 }}>
                      Platform Onboarding Date
                    </Typography>
                    <CustomTextBox
                      type="date"
                      selectedValue={dateOfOnboard}
                      minDate={dateOfJoined}
                      rules={{
                        ...register("onboard_date", {
                          required: "Onboard date is required",
                          validate: (value) =>
                            !dateOfJoined ||
                            new Date(value) >= new Date(dateOfJoined) ||
                            "Platform Onboarding Date cannot be before Date of Joining",
                        }),
                      }}
                      updateDataFunction={handleOnboardDate}
                      errorMessage={errors?.onboard_date?.message}
                      textBoxError={!!errors.onboard_date}
                    />
                  </Mui.Grid>

                  <Mui.Grid item xs={6}>
                    <Typography sx={{ fontWeight: 600 }}>
                      Phone Number
                    </Typography>

                    <CustomTextBox
                      selectedValue={phoneNumber}
                      rules={{
                        ...register("phone_number", {
                          required: "Phone number is required",
                          minLength: {
                            value: 10,
                            message: minimum10Digits,
                          },
                          validate: {
                            employeePhonenumberAvailable: async (
                              fieldValue,
                            ) => {
                              if (fieldValue !== "") {
                                const response = await fetch(
                                  `${domain}unique/phone-number/?phone_no=${fieldValue}`,
                                  {
                                    method: "GET",
                                    headers: {
                                      "Content-Type": "application/json",
                                      Authorization: `token ${token}`,
                                    },
                                  },
                                );
                                const resp = await response.json();
                                if (resp.exists) {
                                  return "Phone number already exists";
                                }
                              }
                            },
                          },
                        }),
                      }}
                      updateDataFunction={updatePhoneNumber}
                      placeHolder="Enter Phone Number"
                      errorMessage={errors?.phone_number?.message}
                      textBoxError={!!errors.phone_number}
                    />
                  </Mui.Grid>
                  <Mui.Grid item xs={6}>
                    <Typography sx={{ fontWeight: 600 }}>Email ID</Typography>
                    <Mui.TextField
                      size="small"
                      {...register("email", {
                        required: false,
                        pattern: {
                          value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                          message: "Invalid e-mail address",
                        },
                        validate: {
                          emailAvailable: async (fieldValue) => {
                            if (fieldValue === "") {
                              return true;
                            }
                            if (fieldValue.length > 254) {
                              return "Email cannot be greater than 254 characters";
                            }
                            try {
                              const response = await fetch(
                                `${domain}unique/email/?email=${fieldValue}`,
                                {
                                  method: "GET",
                                  headers: {
                                    "Content-Type": "application/json",
                                    Authorization: `token ${token}`,
                                  },
                                },
                              );
                              const res = await response.json();
                              if (response.ok) {
                                if (res.exists) {
                                  return "Email already exists";
                                } else {
                                  return true;
                                }
                              } else if (response.status === 409) {
                                sessionHandling();
                              } else {
                                throw new Error('REQUEST_FAILED');
                              }
                            } catch (error) {
                              console.error('[Edituserdetails] operation failed:', error);
                              showToast("error", "Couldn't save employee details. Please try again.");
                            }
                          },
                        },
                      })}
                      error={Boolean(errors.email?.message)}
                      helperText={errors?.email?.message}
                      placeholder="Enter the email"
                      fullWidth
                    />
                  </Mui.Grid>
                  <Mui.Grid item xs={6}>
                    <Typography sx={{ fontWeight: 600 }}>User Code</Typography>
                    <CustomTextBox
                      selectedValue={watch("user_code")}
                      rules={{
                        ...register("user_code", {
                          required: "User code is required",
                          maxLength: {
                            value: 16,
                            message: "Minimum 16 characters are required",
                          },
                          validate: {
                            employeeIdAvailable: async (fieldValue) => {
                              if (fieldValue !== "") {
                                const response = await fetch(
                                  `${domain}unique/user-code/?user_code=${parseInt(
                                    fieldValue,
                                  )}`,
                                  {
                                    method: "GET",
                                    headers: {
                                      "Content-Type": "application/json",
                                      Authorization: `token ${token}`,
                                    },
                                  },
                                );
                                const resp = await response.json();
                                if (resp.exists) {
                                  return "User Code Already Exists";
                                }
                              }
                            },
                          },
                        }),
                      }}
                      updateDataFunction={updateUserCode}
                      placeHolder="Enter the user code"
                      errorMessage={
                        errors?.user_code?.message
                          ? errors?.user_code?.message
                          : ""
                      }
                      textBoxError={errors.user_code ? true : false}
                    />
                    {userCodeError && (
                      <Mui.Typography
                        variant="body2"
                        color="error"
                        sx={{
                          fontSize: 12,
                          paddingLeft: 1.5,
                          paddingTop: 0.5,
                        }}
                      >
                        {"User Code Already Exists"}
                      </Mui.Typography>
                    )}
                  </Mui.Grid>
                </Mui.Grid>
              </Mui.Paper>

              <Mui.Paper sx={{ p: 2, m: 2 }}>
                <Mui.Typography
                  variant="subtitle1"
                  sx={{ mb: 2, fontWeight: "bold" }}
                >
                  Employment Information
                </Mui.Typography>
                <Mui.Grid container spacing={2}>
                  <Mui.Grid item xs={6}>
                    <Typography sx={{ fontWeight: 600 }}>
                      Employee Group
                    </Typography>
                    <CustomAutoComplete
                      dataList={employeeGroup.map((obj) => ({
                        ...obj,
                        label: obj?.group_name,
                      }))}
                      selectedValue={employeeGroupName}
                      rules={{
                        ...register("employee_group_name", {
                          required: "Employee group is required",
                        }),
                      }}
                      updateDataFunction={handleEmployeeGroup}
                      placeHolder="Please select the employee group"
                      errorMessage={errors?.employee_group_name?.message}
                      textBoxError={!!errors?.employee_group_name}
                    />
                  </Mui.Grid>
                  <Mui.Grid item xs={6}>
                    <Typography sx={{ fontWeight: 600 }}>
                      Employment Type
                    </Typography>
                    <CustomAutoComplete
                      dataList={employmentType.map((obj) => ({
                        ...obj,
                        label: obj.employment_type,
                      }))}
                      selectedValue={employmentTypeName}
                      rules={{
                        ...register("employmentType", {
                          required: "Employment Type is required",
                        }),
                      }}
                      updateDataFunction={handleEmploymentType}
                      placeHolder="Please select the employment type"
                      errorMessage={errors?.employmentType?.message}
                      textBoxError={!!errors.employmentType}
                    />
                  </Mui.Grid>
                  <Mui.Grid item xs={6}>
                    <Typography sx={{ fontWeight: 600 }}>Department</Typography>
                    <CustomAutoComplete
                      dataList={department.map((obj) => ({
                        ...obj,
                        label: obj?.department?.toString(),
                      }))}
                      selectedValue={departmentName}
                      rules={{
                        ...register("departmentName", {
                          required: "Department name is required",
                        }),
                      }}
                      updateDataFunction={handleDepartment}
                      placeHolder="Please select the department name"
                      errorMessage={errors?.departmentName?.message}
                      textBoxError={!!errors?.departmentName}
                    />
                  </Mui.Grid>
                  <Mui.Grid item xs={6}>
                    <Typography sx={{ fontWeight: 600 }}>
                      Designation
                    </Typography>
                    <CustomAutoComplete
                      dataList={designation.map((obj) => ({
                        ...obj,
                        label: obj.designation,
                      }))}
                      selectedValue={designationName}
                      rules={{
                        ...register("designation", {
                          required: "Designation is required",
                        }),
                      }}
                      updateDataFunction={handleDesignation}
                      placeHolder="Please select the designation"
                      errorMessage={errors?.designation?.message}
                      textBoxError={!!errors?.designation}
                    />
                  </Mui.Grid>
                </Mui.Grid>
              </Mui.Paper>

              <Mui.Paper sx={{ p: 2, m: 2 }}>
                <Mui.Typography
                  variant="subtitle1"
                  sx={{ mb: 2, fontWeight: "bold" }}
                >
                  Shift & Leave Information
                </Mui.Typography>
                <Mui.Grid container spacing={2}>
                  <Mui.Grid item xs={6}>
                    <Typography sx={{ fontWeight: 600 }}>
                      Shift Grade
                    </Typography>

                    <CustomAutoComplete
                      dataList={shiftGradeData.map((obj) => ({
                        ...obj,
                        label: obj.name,
                      }))}
                      selectedValue={shiftGradeName}
                      rules={{
                        ...register("shiftGradeName", {
                          required: "Shift grade is required",
                        }),
                      }}
                      updateDataFunction={handleShiftGradeName}
                      placeHolder="Please select the shift grade"
                      errorMessage={errors?.shiftGradeName?.message}
                      textBoxError={!!errors?.shiftGradeName}
                    />
                  </Mui.Grid>
                  <Mui.Grid item xs={6}>
                    <Typography sx={{ fontWeight: 600 }}>
                      Shift Group
                    </Typography>
                    <CustomAutoComplete
                      dataList={shiftGroupData.map((obj) => ({
                        ...obj,
                        label: obj.name,
                      }))}
                      selectedValue={shiftGroupName}
                      rules={{
                        ...register("shiftGroup", {
                          required: "Shift group is required",
                        }),
                      }}
                      updateDataFunction={handleShiftGroupName}
                      placeHolder="Please select the shift group"
                      errorMessage={errors?.shiftGroup?.message}
                      textBoxError={!!errors?.shiftGroup}
                    />
                  </Mui.Grid>
                  <Mui.Grid item xs={6}>
                    <Typography sx={{ fontWeight: 600 }}>
                      Shift Category
                    </Typography>
                    <CustomAutoComplete
                      dataList={shiftCatgList.map((obj) => ({
                        ...obj,
                        label: obj.name,
                      }))}
                      selectedValue={shiftCatgName}
                      rules={{
                        ...register("shiftCatgName", {
                          required: "Shift Category is required",
                        }),
                      }}
                      updateDataFunction={handleShiftCatgName}
                      placeHolder="Please select the shift category"
                      errorMessage={errors?.shiftCatgName?.message}
                      textBoxError={!!errors?.shiftCatgName}
                    />
                  </Mui.Grid>
                  <Mui.Grid item xs={6}>
                    <Typography sx={{ fontWeight: 600 }}>
                      Leave Group
                    </Typography>

                    <CustomAutoComplete
                      dataList={userGroup.map((obj) => ({
                        ...obj,
                        label: obj.name,
                      }))}
                      selectedValue={leaveGroupName}
                      rules={{
                        ...register("leaveGroup", {
                          required: "Leave group is required",
                        }),
                      }}
                      updateDataFunction={handleUserLeaveGroup}
                      placeHolder="Please select the leave group"
                      errorMessage={errors?.leaveGroup?.message}
                      textBoxError={!!errors?.leaveGroup}
                    />
                  </Mui.Grid>
                </Mui.Grid>
              </Mui.Paper>

              <Mui.Paper sx={{ p: 2, m: 2 }}>
                <Mui.Typography
                  variant="subtitle1"
                  sx={{ mb: 2, fontWeight: "bold" }}
                >
                  Access & Permissions
                </Mui.Typography>
                <Box sx={childBoxStyleSpaceBetween}>
                  <Switch
                    checked={checkBoxValue}
                    onChange={updateCheckBoxValue}
                  />
                  <Box sx={{ display: "flex", flexDirection: "column" }}>
                    <Typography sx={{ fontWeight: 600 }}>
                      Portal Access
                    </Typography>
                    <Typography {...infoStyle}>
                      The employee will be able to submit their leaves,
                      reimbursement claims, view, and generate payslips through
                      the employee portal.
                    </Typography>
                  </Box>
                </Box>
              </Mui.Paper>

              <Mui.Grid container sx={{ padding: 2 }}>
                <Mui.Grid xs={3}>
                  <CustomButton
                    actionFuntion={() => {
                      setOpenSidePeek(false);
                    }}
                    actionName="Cancel"
                    typeName="button"
                  />
                </Mui.Grid>
                <Mui.Grid xs={6}></Mui.Grid>
                <Mui.Grid
                  xs={3}
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "flex-end",
                    alignItems: "flex-end",
                  }}
                >
                  <CustomButton
                    actionName="Re-Verify"
                    typeName="submit"
                    actionFuntion={handleSubmit(handleUpdateUserDetails)}
                  />
                </Mui.Grid>
              </Mui.Grid>

              <Mui.Grid
                container
                sx={{
                  paddingBottom: {
                    xs: 2,
                    sm: 4,
                    md: 4,
                    lg: 5,
                    xl: 5,
                    xxl: 5,
                  },
                }}
              />
            </form>
          </Box>
        </Box>
      </Box>
    </Drawer>
  );
};
